import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

export interface BevallasSor { id: number; kod: string; nev: string; irany: string | null; aktiv: number; sorrend: number; }

/**
 *  „BEVALLÁSI SOR KIVÁLASZTÁSA" (RLB mintájára) – kereshető lista az ÁFA-bevallási sorok
 *  törzséből (naplo_bevallas_sor). Kattintás = kijelölés, dupla kattintás / Enter / „Kiválaszt"
 *  = választás. A kettős számlasor-ablak és az egyszeres tételsor is ezt használja.
 */
@Component({
  selector: 'app-naplo-bevsor-valaszto',
  templateUrl: './bevsor-valaszto.component.html',
  styleUrls: ['../naplo-shared.scss', './bevsor-valaszto.component.scss'],
})
export class BevsorValasztoComponent implements OnInit {
  @Input() aktualis: string | null = null;
  @Output() valaszt = new EventEmitter<BevallasSor>();
  @Output() megse = new EventEmitter<void>();

  sorok: BevallasSor[] = [];
  kereses = '';
  kijelolt: BevallasSor | null = null;
  betoltes = true;

  constructor(private http: HttpClient) {}

  async ngOnInit() {
    try { this.sorok = await firstValueFrom(this.http.get<BevallasSor[]>('/api/naplo-naplok/bevallas-sorok')); } catch { this.sorok = []; }
    this.kijelolt = this.sorok.find((s) => s.kod === this.aktualis) || this.lathato[0] || null;
    this.betoltes = false;
    setTimeout(() => document.querySelector('app-naplo-bevsor-valaszto tr.kijelolt')?.scrollIntoView({ block: 'center' }), 50);
  }

  get lathato(): BevallasSor[] {
    const k = this.kereses.trim().toLowerCase();
    if (!k) return this.sorok;
    return this.sorok.filter((s) => s.kod.toLowerCase().startsWith(k) || s.nev.toLowerCase().includes(k));
  }

  keresValt() { if (!this.kijelolt || !this.lathato.includes(this.kijelolt)) this.kijelolt = this.lathato[0] || null; }

  billentyu(e: KeyboardEvent) {
    const l = this.lathato;
    const i = this.kijelolt ? l.indexOf(this.kijelolt) : -1;
    if (e.key === 'ArrowDown') { e.preventDefault(); this.kijelolt = l[Math.min(l.length - 1, i + 1)] || null; }
    else if (e.key === 'ArrowUp') { e.preventDefault(); this.kijelolt = l[Math.max(0, i - 1)] || null; }
    else if (e.key === 'Enter') { e.preventDefault(); this.kivalaszt(); }
    else if (e.key === 'Escape') { this.megse.emit(); }
    setTimeout(() => document.querySelector('app-naplo-bevsor-valaszto tr.kijelolt')?.scrollIntoView({ block: 'nearest' }), 0);
  }

  kivalaszt(s: BevallasSor | null = this.kijelolt) { if (s) this.valaszt.emit(s); }
}
